import Image from 'common/components/Image';
import React from 'react';
import { TokenIcon, TokenName } from './TokenIcon';
import { StyledTokenIcons } from './tokenIcons.style';

type Props = {
  tokenNames?: string[];
};

export const TokenIcons: React.FC<Props> = (props) => {
  if (!props.tokenNames || props.tokenNames.length === 0) {
    // The absense of tokens would indicate a balance pool token
    return (
      <StyledTokenIcons>
        <Image className="icon-bpt" alt="balance pool icon" />
      </StyledTokenIcons>
    );
  }
  return (
    <StyledTokenIcons>
      {props.tokenNames.map((name, idx) => (
        <TokenIcon key={name} name={name as TokenName} marginLeft={idx > 0 ? '3px' : undefined} />
      ))}
    </StyledTokenIcons>
  );
};
